// First Created - 16 May 2025
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userSessionMissionPlansAdapter = createEntityAdapter({})

const initialState = userSessionMissionPlansAdapter.getInitialState()

export const userSessionMissionPlansApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserSessionMissionPlans: builder.query({
            query: () => ({
                url: '/userSessionMissionPlans/getUserSessionMissionPlans',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserSessionMissionPlans = responseData.map(userSessionMissionPlan => {
                    userSessionMissionPlan.id = userSessionMissionPlan._id
                    return userSessionMissionPlan
                })
                return userSessionMissionPlansAdapter.setAll(initialState, loadedUserSessionMissionPlans)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserSessionMissionPlan', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserSessionMissionPlan', id}))
                    ]
                } else {
                    return [ { type: 'UserSessionMissionPlan', id: 'LIST'}]
                }
            },
        }),
        createNewUserSessionMissionPlan: builder.mutation({
            query: initialUserSessionMissionPlan => ({
                url: '/userSessionMissionPlans/createNewUserSessionMissionPlan',
                method: 'POST',
                body: {...initialUserSessionMissionPlan,}
            }),
            invalidatesTags: [
                { type: 'UserSessionMissionPlan', id: "LIST" }
            ] 
        }),
        updateUserSessionMissionPlan: builder.mutation({
            query: initialUserSessionMissionPlan => ({
                url: '/userSessionMissionPlans/updateUserSessionMissionPlan',
                method: 'PATCH',
                body: {...initialUserSessionMissionPlan,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserSessionMissionPlan', id: arg.id },
                { type: 'UserSessionMissionPlan', id: 'LIST' }
            ],
        }),
        deleteUserSessionMissionPlan: builder.mutation({
            query: ({id}) => ({
                url: '/userSessionMissionPlans/deleteUserSessionMissionPlan',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserSessionMissionPlan', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserSessionMissionPlansQuery,
    useCreateNewUserSessionMissionPlanMutation,
    useUpdateUserSessionMissionPlanMutation,
    useDeleteUserSessionMissionPlanMutation,
} = userSessionMissionPlansApiSlice

// returns the query result object
export const selectUserSessionMissionPlanResult = userSessionMissionPlansApiSlice.endpoints.getUserSessionMissionPlans.select()

// create memoized selector
const selectUserSessionMissionPlansData = createSelector(
    selectUserSessionMissionPlanResult,
    userSessionMissionPlanResult => userSessionMissionPlanResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserSessionMissionPlans,
    selectById: selectUserSessionMissionPlanById,
    selectIds: selectUserSessionMissionPlanIds,
} = userSessionMissionPlansAdapter.getSelectors(state => selectUserSessionMissionPlansData(state) ?? initialState)